import { FC } from 'react';

import Button from '../common/button';
// Ensure in index.html: <link href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined" rel="stylesheet" />

interface PermissionsModalProps {
  open: boolean;
  onClose: () => void;
  onRequestPermissions?: () => void;
}

export const PermissionsModal: FC<PermissionsModalProps> = ({
  open,
  onClose,
  onRequestPermissions,
}) => {
  // Helper to open browser site settings for current origin
  const openSiteSettings = () => {
    const origin = window.location.origin;
    const tryOpen = (url: string) => {
      try { window.open(url, '_blank') } catch {}
    };

    if (isIOS) {
      alert('Откройте «Настройки > Safari > Камера/Микрофон» и разрешите доступ для этого сайта.');
      return;
    }
    if (isAndroid) {
      alert('Откройте настройки браузера → «Разрешения сайта» → Разрешите доступ к камере и микрофону.');
      return;
    }
    if (ua.includes('edg/')) return tryOpen(`edge://settings/content/siteDetails?site=${origin}`);
    if (ua.includes('opr/')) return tryOpen(`opera://settings/content/siteDetails?site=${origin}`);
    if (ua.includes('brave')) return tryOpen(`brave://settings/content/siteDetails?site=${origin}`);
    if (ua.includes('chrome')) return tryOpen(`chrome://settings/content/siteDetails?site=${origin}`);
    if (ua.includes('firefox')) return tryOpen('about:preferences#privacy');
  };

  if (!open) return null;
  const ua = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua);
  const isAndroid = /android/.test(ua);
  const isFirefox = ua.includes('firefox');
  const isSafari = ua.includes('safari') && !ua.includes('chrome');
  const isChromium = ua.includes('chrome') || ua.includes('edg/') || ua.includes('opr/') || ua.includes('brave');

  return (
    <div className="fixed top-0 left-0 px-5 w-full h-full flex flex-col items-center justify-center backdrop-blur-sm z-[99999999999]">
      <div className="w-full max-w-[435px] border-[2px] bg-white border-[#dd777b] p-[15px] rounded-[14px] flex flex-col gap-[10px]">
        <button
          type="button"
          disabled
          className="mx-auto mb-2 flex items-center justify-center rounded-full bg-[#fdecea] w-20 h-20"
        >
          <span className="material-symbols-outlined text-[#dd777b]" style={{ fontSize: '40px' }}>
            videocam
          </span>
        </button>
        <h2 className="text-[18px] font-semibold text-center">Нужно разрешение на камеру и микрофон</h2>
        <p className="text-[13px] text-gray-600 text-center">Нажмите <b>Разрешить</b> в браузере. Вы сможете выключить камеру и микрофон в любой момент.</p>
        <div className="mt-1 flex flex-col sm:flex-row gap-2">
          <Button onClick={onRequestPermissions} className="!text-xs font-comfortaa text-center">
            Запросить доступ
          </Button>
          <Button onClick={openSiteSettings} className="!text-xs font-comfortaa text-center">
            Настройки сайта
          </Button>
          <Button type={'black'} onClick={onClose} className="!font-bol1d !text-xs font-comfortaa text-center flex items-center justify-center">
            Понятно
          </Button>
        </div>
        <details className="mt-1 text-[13px] text-gray-700">
          <summary className="cursor-pointer select-none">Как это сделать в разных браузерах?</summary>
          <div className="mt-2 space-y-2">
            {isChromium && (
              <div>
                <div className="font-medium">Chrome / Edge / Brave / Opera</div>
                <ol className="list-decimal pl-5">
                  <li>Нажмите на значок замка слева от адреса.</li>
                  <li>В разделе «Разрешения» поставьте «Разрешить» для Камеры и Микрофона.</li>
                  <li>Обновите страницу.</li>
                </ol>
              </div>
            )}
            {isSafari && !isIOS && (
              <div>
                <div className="font-medium">Safari (macOS)</div>
                <ol className="list-decimal pl-5">
                  <li>Откройте Safari → Settings → Websites.</li>
                  <li>Camera и Microphone → выберите для {window.location.host} «Allow».</li>
                  <li>Перезагрузите страницу.</li>
                </ol>
              </div>
            )}
            {isFirefox && (
              <div>
                <div className="font-medium">Firefox</div>
                <ol className="list-decimal pl-5">
                  <li>Нажмите на значок замка слева от адреса.</li>
                  <li>Разрешения сайта → Камера/Микрофон → «Разрешить».</li>
                  <li>Обновите страницу.</li>
                </ol>
              </div>
            )}
            {isIOS && (
              <div>
                <div className="font-medium">iOS (Safari)</div>
                <ol className="list-decimal pl-5">
                  <li>Откройте настройки устройства.</li>
                  <li>Перейдите в Safari → Камера/Микрофон.</li>
                  <li>Разрешите доступ для {window.location.host}.</li>
                </ol>
              </div>
            )}
            {isAndroid && (
              <div>
                <div className="font-medium">Android (Chrome / другие)</div>
                <ol className="list-decimal pl-5">
                  <li>Откройте настройки браузера.</li>
                  <li>Найдите «Разрешения сайта».</li>
                  <li>Разрешите доступ к Камере и Микрофону для {window.location.host}.</li>
                </ol>
              </div>
            )}
          </div>
        </details>
      </div>
    </div>
  );
};